import React, { useState, memo } from "react";
import Service from '../../../service/Service';
import AddGrowthDetails from "./AddGrowthDetails";
import { Link } from "react-router-dom";

const service = new Service();

// import { render } from "react-dom";

// export default function Nonloggedin({ eleRef , type }) {
function Nonloggedin({ eleRef, type }) {

    const isDesktop = eleRef.state.isDesktop;

    const [activeHoverTab, setActiveHoverTab] = useState(null);

    const AddGrowth =()=>{
        eleRef.setState({
            gotoFirstpage: false,
        })
    }

    // const goback = () => {
    //     window.history.back();
    // };
    const goback = () => {
        let isApp = window.location.href.includes("from=app");
        if (!isApp) {
            window.history.back();
            return;
        }
        const currentUrl = window.location.href;
        window.history.back();
        setTimeout(() => {
            // Still on same page => history back did not navigate
            if (window.location.href === currentUrl) {
                let deepjson = {
                    appurl: [
                        {
                            pagetype: "onBackPressed",
                            isFinishWindow: true
                        }
                    ]
                };
                service.jsontracker(JSON.stringify(deepjson));
            }
        }, 500);
    };

    // const pagetypeCallbackVCC = (e) =>{

    //     let  isApp = window.location.href.includes("from=app");

    //     if(isApp){
    //          e.preventDefault();
    //             let deepjson = {
    //                 appurl: [
    //                     {
    //                         pagetype: "vaccination",
    //                         requestURL: "tools/vaccine-immunization-tracker/?from=app"
    //                     }
    //                 ]
    //             };
    //             service.jsontracker(JSON.stringify(deepjson));
    //     }

    // }

    // const pagetypeCallbackGrowth = (e) =>{

    //     let  isApp = window.location.href.includes("from=app");

    //     if(isApp){
    //          e.preventDefault();
    //             let deepjson = {
    //                 appurl: [
    //                     {
    //                         pagetype: "communitygrowthtracker",
    //                         requestURL: "tools/baby-growth-tracker-chart/?from=app"
                            
    //                     }
    //                 ]
    //             };
    //             service.jsontracker(JSON.stringify(deepjson));
    //     }

    // }

    return (
        <div className="non_login_container">
            <div className="non_loggedin" id="non_loggedin">
                <div className="nonlog_slider_wrapper">    
                    {!isDesktop &&
                        <div className="vaccinationTitle">
                            <span className="nonlog_vcc_Title" onClick={goback} aria-label="Child Immunization & Baby Growth Tracker">
                                <img className="mob_back_arrow" src="https://cdn.cdnparenting.com/brainbees/community/vaccination/left_arrow.png" alt="back img"></img>
                                {type == "vaccination"?"Vaccination":"Growth" }  Tracker
                            </span>
                        </div>
                    }
                    <div className="tracker_tab">
                        <div className="tracker_tab_box">

                            <div className="growthTracker topTab" onMouseEnter={() => setActiveHoverTab("growth")} onMouseLeave={() => setActiveHoverTab(null)} >
                                <div className={`growthTracker_div ${(activeHoverTab || type) === "growth" ? "activetopTab" : ""}`} >
                                    <a href={eleRef.state.isApp ? "/tools/baby-growth-tracker-chart/?from=app" : "/tools/baby-growth-tracker-chart/"}>
                                    {/* <Link to={eleRef.state.isApp ? "/tools/baby-growth-tracker-chart/?from=app" : "/tools/baby-growth-tracker-chart/"}  > */}
                                        {type === "growth" ? (
                                            <h1 className="growth_heading">{eleRef.state.isDesktop ? "GROWTH TRACKER" : "GROWTH"}</h1>
                                        ):(
                                            <>{eleRef.state.isDesktop ? "GROWTH TRACKER" : "GROWTH"}</>
                                        )}
                                    {/* </Link> */}
                                    </a>

                                    <span className="grtBorder"></span>
                                </div>
                            </div>

                            <div className="vaccinTracker topTab" onMouseEnter={() => setActiveHoverTab("vaccination")} onMouseLeave={() => setActiveHoverTab(null)}>
                                <div className={`vccTracker_div ${(activeHoverTab || type) === "vaccination" ? "activetopTab" : "" }`}  > 
                                    {eleRef.state.isLoggedin && eleRef.state.childlist.length > 0 ? (
                                        <a href={service.getRedirectUrl("/tools/vaccine-immunization-tracker/")}>
                                            {type === "vaccination" ? (
                                                <h1 className="vaccination_heading">{eleRef.state.isDesktop ? "VACCINATION TRACKER" : "VACCINATION"}</h1>
                                            ):(
                                                <>{eleRef.state.isDesktop ? "VACCINATION TRACKER" : "VACCINATION"}</>
                                            )}
                                        </a>

                                    ):(
                                        <a href={eleRef.state.isApp ? "/tools/vaccine-immunization-tracker/?from=app" : "/tools/vaccine-immunization-tracker/"}>
                                         {/* <Link to={eleRef.state.isApp ? "/tools/vaccine-immunization-tracker/?from=app" : "/tools/vaccine-immunization-tracker/"}> */}
                                            {type === "vaccination" ? (
                                                <h1 className="vaccination_heading">{eleRef.state.isDesktop ? "VACCINATION TRACKER" : "VACCINATION"}</h1>
                                            ):(
                                                <>{eleRef.state.isDesktop ? "VACCINATION TRACKER" : "VACCINATION"}</>
                                            )}
                                        {/* </Link>  */}
                                        </a>
                                    )}
                                    

                                    <span className="vccBorder"></span>
                                </div>
                            </div>

                        </div>
                    </div>    
                    <div className="banner_card">
                        {type == "growth" ?(
                            isDesktop ? (
                                <img src="https://cdn.cdnparenting.com/brainbees/community/vaccination/growth%20tracker-desktop-banner.png" alt="Child Growth Tracker" title="Child Growth Tracker" className="GTMTopBanner" data-page="growth" onClick={eleRef.toLogin} />
                            ):(
                                <img src="https://cdn.cdnparenting.com/brainbees/community/vaccination/babyGrowth_mobile.png" alt="Child Growth Tracker" title="Child Growth Tracker" className="GTMTopBanner" onClick={(e) => {eleRef.growthBannerEvent(e); eleRef.toLogin();}}  /> //onClick={eleRef.growthBannerEvent}
                            )   
                            
                        ):(
                            isDesktop ? (
                                <img src="https://cdn.cdnparenting.com/brainbees/community/vaccination/Vaccination-tracker.png" alt="Child Immunization & Vaccination Schedule" title="Child Immunization & Vaccination Schedule" className="GTMTopBanner" data-page="vaccination" onClick={eleRef.toLogin} />
                            ):(
                                <img src="https://cdn.cdnparenting.com/brainbees/community/vaccination/Vaccination-tracker-mobile-banner.png" className="GTMTopBanner" alt="Child Immunization & Vaccination Schedule" title="Child Immunization & Vaccination Schedule"  onClick={(e) => {eleRef.bannerEvent(e); eleRef.toLogin();}} />
                            )
                            
                        )}
                    
                    </div>
                </div>
                <div className={`${type == "growth" ?"infoBox_growth":"infoBox"} `}>
                    {isDesktop ? (
                    <>
                    <div className="infoBoxInner">
                        <div className="infoText bgcolour">
                            {type == "growth" ?(
                                <>
                                    <img className="infoTextImg" src="https://cdn.cdnparenting.com/brainbees/community/vaccination/growth%20chart.svg" alt=""/>
                                    <span className="infoTextDesc R18_42">Personalized Growth Charts based on age and gender</span>
                                </>
                            ):(
                                <>
                                    <img className="infoTextImg" src="https://cdn.cdnparenting.com/brainbees/community/vaccination/Group4484.png" alt=""/>
                                    <span className="infoTextDesc R18_42">Digitally store and organize vaccination records</span>
                                </>
                                
                            )}
                            
                        </div>
                        <div className="infoText bgcolour1">
                            {type == "growth" ?(
                                <>
                                    <img className="infoTextImg" src="https://cdn.cdnparenting.com/brainbees/community/vaccination/earth%20icon.svg" alt=""/>
                                    <span className="infoTextDesc R18_42">Tracking health development via WHO standards</span>
                                </>
                            ):(
                                <>
                                    <img className="infoTextImg" src="https://cdn.cdnparenting.com/brainbees/community/vaccination/Group4477.png" alt=""/>
                                    <span className="infoTextDesc R18_42">Identify any missing or overdue vaccines</span>
                                </>
                            )}
                            
                        </div>
                        <div className="infoText bgcolour2">
                            {type == "growth" ?(
                                <>
                                    <img className="infoTextImg" src="https://cdn.cdnparenting.com/brainbees/community/vaccination/notification.svg" alt=""/>
                                    <span className="infoTextDesc R18_42">Smart Reminders for timely updates and health check-ins</span>
                                </>
                            ):(
                                <>
                                    <img className="infoTextImg" src="https://cdn.cdnparenting.com/brainbees/community/vaccination/Group%204474.png" alt=""/>
                                    <span className="infoTextDesc R18_42">Stay updated on upcoming & completed vaccinations</span>
                                </>
                            )}
                            
                        </div>
                        <div className="infoText bgcolour3">
                            {type == "growth" ?(
                                <>
                                    <img className="infoTextImg" src="https://cdn.cdnparenting.com/brainbees/community/vaccination/email%20icon.svg" alt=""/>
                                    <span className="infoTextDesc R18_42">Digital Records to maintain and access growth history anytime</span>
                                </>
                            ):(
                                <>
                                    <img className="infoTextImg" src="https://cdn.cdnparenting.com/brainbees/community/vaccination/Group14477.png" alt=""/>
                                    <span className="infoTextDesc R18_42">Learn more about vaccines & their importance</span>
                                </>
                            )}
                            
                        </div>
                    </div>

                    {eleRef.state.gotoFirstpage ?(
                        <div className="growth_askB_1 non-login" onClick={AddGrowth}>
                            <span className="M17_addChild">Add Growth Details</span>
                        </div>
                    ):(
                        <div className={`growth_askB_1 non-login`} onClick={eleRef.toLogin}>
                            <span className="M17_addChild">Add Your Child Details</span>
                        </div>
                    )}



                    </>
                    ):(
                    <>
                        <div className="infoBoxInner">

                            <div className="infoText bgcolour">
                                {type == "growth" ?(
                                    <>
                                        <img className="infoTextImg" src="https://cdn.cdnparenting.com/brainbees/community/vaccination/growth%20chart.svg" alt=""/>
                                        <span className="infoTextDesc R18_42">Personalized Growth Charts based on age and gender</span>
                                    </>
                                    
                                ):(
                                    <>
                                        <img className="infoTextImg" src="https://cdn.cdnparenting.com/brainbees/community/vaccination/Group4484.png" alt=""/>
                                        <span className="infoTextDesc R18_42">Digitally store and organize vaccination records</span>
                                    </>
                                    
                                )}
                                
                            </div>
                            <div className="infoText bgcolour1">
                                {type == "growth" ?(
                                    <>
                                        <img className="infoTextImg" src="https://cdn.cdnparenting.com/brainbees/community/vaccination/earth%20icon.svg" alt=""/>
                                        <span className="infoTextDesc R18_42">Tracking health development via WHO standards</span>
                                    </>
                                ):(
                                    <>
                                        <img className="infoTextImg" src="https://cdn.cdnparenting.com/brainbees/community/vaccination/Group4477.png" alt=""/>
                                        <span className="infoTextDesc R18_42">Identify any missing or overdue vaccines</span>
                                    </>
                                )}
                                
                            </div>
                            <div className="infoText bgcolour2">
                                {type == "growth" ?(
                                    <>
                                        <img className="infoTextImg" src="https://cdn.cdnparenting.com/brainbees/community/vaccination/notification.svg" alt=""/>
                                        <span className="infoTextDesc R18_42">Smart Reminders for timely updates and health check-ins</span>
                                    </>
                                ):(
                                    <>
                                        <img className="infoTextImg" src="https://cdn.cdnparenting.com/brainbees/community/vaccination/Group%204474.png" alt=""/>
                                        <span className="infoTextDesc R18_42">Stay updated on upcoming & completed vaccinations</span>
                                    </>
                                )}
                                
                            </div>
                            <div className="infoText bgcolour3">
                                {type == "growth" ?(
                                    <>
                                        <img className="infoTextImg" src="https://cdn.cdnparenting.com/brainbees/community/vaccination/email%20icon.svg" alt=""/>
                                        <span className="infoTextDesc R18_42">Digital Records to maintain and access growth history anytime</span>
                                    </>
                                ):(
                                    <>
                                    <img className="infoTextImg" src="https://cdn.cdnparenting.com/brainbees/community/vaccination/Group14477.png" alt=""/>
                                    <span className="infoTextDesc R18_42">Learn more about vaccines & their importance</span>
                                    </>
                                )}
                                
                            </div>
                            {eleRef.state.gotoFirstpage ?(
                                <div className="growth_askB_1 non-login" onClick={AddGrowth}>
                                    <span className="M17_addChild">Add Growth Details</span>
                                </div>
                            ):(
                                <div className={`growth_askB_1 non-login`} onClick={eleRef.toLogin}>
                                    <span className="M17_addChild">Add Your Child Details</span>
                                </div>
                            )}
                        </div>
                    </>
                    )}

                </div>
            </div>

            {isDesktop &&
                <div className="nonloggedin_add_container"  >
                        <div className=" advertisementRight_growth">
                            <div style={{textAlign: "center",padding: "15px 0px 11px",fontSize: "12px",}}>ADVERTISEMENT</div>
                            <div className="rightside">
                                <div id="c21ba44c-f89a-460f-bbb9-bc29c66647af"
                                    className="_ap_apex_ad"
                                    style={{ width: "336px", height: "280px" }}
                                >
                                    {/* <img src="https://cdn.cdnparenting.com/brainbees/community/vaccination/912117783681748523%201.png"></img> */}
                                </div>
                            </div> 
                        </div>

                        <div className=" advertisementRight_growth">
                            <div style={{textAlign: "center",padding: "15px 0px 11px",fontSize: "12px",}}>ADVERTISEMENT</div>
                            <div className="rightside">
                                <div id="1f428a2d-000a-439a-8305-6d9c86cf257a"
                                    className="_ap_apex_ad"
                                    style={{ width: "336px", height: "280px" }}
                                >
                                    {/* <img src="https://cdn.cdnparenting.com/brainbees/community/vaccination/912117783681748523%201.png"></img> */}

                                </div>
                            </div> 
                        </div>

                </div>
            }
        </div>
    );
}

export default memo(Nonloggedin);